export class UserValidation {
  active = true;
  service: string;
  fallback_service: string;
  places_to_validate: string [];
  services: UserValidationServiceProvider;
}

export class UserValidationServiceProvider {
  face_rec_serv: {active: boolean};
  SMS_serv: {active: boolean};
}
